'use client';

import React from "react";
import { SubCategory } from "../../../types";
import ServiceCategoryRowGallery from "./ServiceCategoryRowGallery";
import ServiceCategoryRowContent from "./ServiceCategoryRowContent";

export type ServiceCategoryRowProps = {
    category: SubCategory;
    showPoints?: boolean;
    alternate?: boolean;
    dark?: boolean;
    overlineTitle?: string;
    classes?: string;
};

export default function ServiceCategoryRow({
                                               category,
                                               showPoints = false,
                                               alternate = false,
                                               dark = false,
                                               overlineTitle,
                                               classes = "",
                                           }: ServiceCategoryRowProps) {

    const gallery = (
        <ServiceCategoryRowGallery images={category?.images} />
    );

    const content = (
        <ServiceCategoryRowContent
            category={category}
            showPoints={showPoints}
            overlineTitle={overlineTitle}
            dark={dark}
        />
    );

    return (
        <div className={`w-full min-w-0 text-gray-900 md:py-8 sm:py-3 ${classes}`}>
            <div className="
        bg-white shadow-sm
        py-10 px-3 sm:py-2
        md:px-3 md:py-6 md:mt-4
        md:mx-auto md:rounded-[10px] md:text-center
      ">
                <div className="flex justify-center mx-auto min-w-0">
                    <div className="w-full min-w-0 grid grid-cols-12 gap-5 text-center md:max-w-md lg:max-w-full mx-auto">

                        {/* Left column */}
                        <div
                            className={`
                col-span-12 lg:col-span-6 min-w-0
                ${alternate ? "lg:order-2" : "lg:order-1"}
              `}
                        >
                            {/* Content always visible */}
                            {content}
                        </div>

                        {/* Right column */}
                        <div
                            className={`
                col-span-12 lg:col-span-6 min-w-0
                ${alternate ? "lg:order-1" : "lg:order-2"}
                hidden lg:block
              `}
                        >
                            {gallery}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
